<template>
  <div
    v-if="show"
    :class="$.gradient"
  />
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
};
</script>

<style module='$' lang='less'>
.gradient {
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 56px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
}
</style>
